<app-loading-indicator [loading]="loading"></app-loading-indicator>
<div *ngIf="!loading && !recipeItemsNotAvailable">
  <app-product-recipe-table [items]="items" [showHeader]="true"></app-product-recipe-table>
</div>
<p-message *ngIf="recipeItemsNotAvailable" class="p-d-block" [style]="{width: '100%', padding: '10px 0'}" severity="info" [text]="'PRODUCT_RECIPE_NOT_AVAILABLE'|translate"></p-message>
